import { BaseService } from '../base.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { API_CANCEL_SHIFT, API_CHECKOUT_SHIFT, API_FETCH_AGENCY, API_FETCH_TEAM_MEMBER, API_INVOICE_BY_ID, API_JOB, API_FETCH_DASHBOARD, API_ASSIGN_ENTITY_IN_PROJECT, API_CREATE_ENTITY, GET_QUOTATION, UPDATE_QUOTATION_STATUS, GET_PROJECTS_BY_ENTITYID, GET_PO, UPDATE_PO_STATUS, API_WORK_ORDER_EXPORT, GET_BILLINGS, API_WORK_ORDER, UPLOAD_SIGNATURE, API_ENTERPRISE_SIGN_CONTRACT, FETCH_SIGNED_DOCUMENT, API_FETCH_ENTITIES, API_FETCH_TEAM_MEMBER_V2, API_FETTCH_ASSIGNED_VENDORS, API_JOB_APPLICATION, API_TIMESHEET, API_TIMESHEET_FILTER, CREATE_PROJECT, GET_ALL_AGENTS, GET_ALL_PROJECTS, UPDATE_PROJECT, DELETE_PROJECT, GET_ALL_AGENTS_LIST, GET_ALL_OUTCOMES, CREATE_LEADS_USER, PROJECT_HOA_URL, PROJECT_HOA_LEADS_URL, API_HOA_CLONE_PROJECT, API_VIDEO_STREAM, API_KEYWORD, API_DETECTION, CREATE_LEADS_USER_HOA, API_INVITE_AGENT, PROJECT_CHAT_URL, UPDATE_ICP_API, PROJECT_API_KEY, GET_HOA_PROJECT_INITIAL_EMAIL_TEMPLATE, SEND_INITIAL_EMAIL, API_HOA_WORKFLOW_PAUSE, API_GET_JOB_SEEKER_DETAILS_BY_ENTITYID, PLIVO_PHONE_NUMBER, PURCHASED_PHONE_NUMBERS, PURCHASE_PHONE_NUMBER, PROJECT_LEADS_STATUS_API, API_UPDATE_TASK_COMPLETION,
  API_APPROVE_ADD_IN_OTHER_PROJECT, API_UPDATE_PROJECT_NAME, GET_OUTREACH_ACTIVITY_BUFFER, DOWNLOAD_CONNECTED_LEADS_EXCEL, DOWNLOAD_CONNECTED_LEADS_EXCEL_STATUS, DOWNLOAD_PROJECT_WHATSAPP_DOCUMENTS, HOA_ENTITY_OUTCOMES_FILTER, API_UPDATE_JOBS_STATUS_HUMAN_REVIEW, GET_CALL_ANALYSIS_LOGS, GET_CALL_ANALYSIS_LOG, GET_CALL_ANALYSIS_PROMPT_TEMPLATE, REPLAY_CALL_ANALYSIS, REPLAY_CALL_ANALYSIS_BATCH, GENERATE_OUTCOME_DEFINITIONS, START_OUTCOME_REVIEW_CHAT, CONTINUE_OUTCOME_REVIEW_CHAT, GET_OUTCOME_REVIEW_CHAT, APPLY_OUTCOME_REVIEW_CHAT, REEVALUATE_CALL_ANALYSIS, BACKFILL_JEV_OUTCOME, START_BACKFILL_JEV_OUTCOME_PROJECT, BACKFILL_JEV_OUTCOME_PROJECT_STATUS, START_OUTCOME_ACCURACY_SEARCH, OUTCOME_ACCURACY_SEARCH_STATUS, OUTCOME_ACCURACY_SEARCH_OUTCOMES, APPLY_OUTCOME_ACCURACY_SEARCH_RESULT, EDIT_PROJECT_TASKS, EDIT_PROJECT_TASKS_STATUS } from '../util/api.endpoints';
import { Injectable } from '@angular/core';
import { API_CHAT_HUMAN_REPLY, API_CHAT_TAKEOVER, API_UPDATE_JOB_STATUS } from '../util/api.endpoints';
import { Job } from 'src/@core/interfaces/job/job.model';
import { BehaviorSubject, Observable, Subject, throwError, timer, of } from 'rxjs';
import { PageableResponse } from 'src/@core/interfaces/pageable-response';
import * as _ from 'lodash';
import { S3File } from 'src/@core/interfaces/s3-file.model';
import { AuthService } from '../auth.service';
import { catchError, last, map, switchMap, takeWhile, tap } from 'rxjs/operators';

export interface ChatTakeoverState {
  active: boolean;
  by: string;
  started_at: number | null;
  channel: 'whatsapp' | 'website';
}

/**
 * Service response for fetch, create, update and delete the Job.
 */
@Injectable({
  providedIn: 'root'
})
export class JobService extends BaseService<Job> {
  private readonly storageKey = 'generate_bill';
  public refreshQuotePage = new Subject<any>();
  public refreshPOPage = new Subject<any>();
  public refreshWorkorderPage = new Subject<any>();
  public refreshBillingPage = new Subject<any>();

  private detectionResultsSubject = new BehaviorSubject<any>({}); // Store alert detection results
  detectionResults$ = this.detectionResultsSubject.asObservable(); // Observable for real-time updates

  // Inside the JobService class
  private tabIndexSubject = new BehaviorSubject<number>(0);
  tabIndex$ = this.tabIndexSubject.asObservable();


  constructor(private http: HttpClient, private authService: AuthService) {
    super(http, API_JOB);
  }

  getCancelShiftDetails(id) {
    const url = API_CANCEL_SHIFT + '/info/' + id;
    console.log(url)
    return this.http.get<any>(url);
  }

  cancelShift(request) {
    const url = API_CANCEL_SHIFT;
    console.log(url)
    return this.http.post<any>(url, request);
  }

  getEmployementDetails(id) {
    const url = API_CHECKOUT_SHIFT + '/fetch?employmentId=' + id;
    return this.http.get<any>(url);
  }

  deleteJobTemplate(id) {
    const url = API_JOB + '/' + id;
    return this.http.delete<any>(url);
  }

  getInvoiceDetails(id) {
    const url = API_INVOICE_BY_ID + '/' + id;
    return this.http.get<any>(url);
  }

  searchAndSortAgencies(entityId: any, page: number, size: number, sort: string, order: string, searchList?: any[], cacheKey?: any): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = null;
    if (entityId) {
      url = API_FETCH_AGENCY + '/' + entityId + '?page=' + page;
    } else {
      url = API_FETCH_AGENCY + '?page=' + page;
    }
    if (size != null) {
      url += '&size=' + size;
    }

    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

  searchAndSortEnterprises(entityId: any, page: number, size: number, sort: string, order: string, searchList?: any[], cacheKey?: any): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = null;
    url = API_CREATE_ENTITY + '?page=' + page;
    if (size != null) {
      url += '&size=' + size;
    }

    if (entityId) {
      if (entityId) {
        url += '&entityId=' + entityId;
      }
    }
    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

  searchAndSortTeamMembers(entityId: any, page: number, size: number, sort: string, order: string, searchList?: any[], cacheKey?: any): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = null;
    if (entityId) {
      url = API_FETCH_TEAM_MEMBER + '/' + entityId + '?page=' + page;
    } else {
      url = API_FETCH_TEAM_MEMBER + '?page=' + page;
    }
    if (size != null) {
      url += '&size=' + size;
    }

    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

  searchAndSortTeamMembersv2(entityId: any, page: number, size: number, sort: string, order: string, searchList?: any[], cacheKey?: any): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = null;
    if (entityId) {
      url = API_FETCH_TEAM_MEMBER_V2 + '/' + entityId + '?page=' + page;
    } else {
      url = API_FETCH_TEAM_MEMBER_V2 + '?page=' + page;
    }
    if (size != null) {
      url += '&size=' + size;
    }

    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

  searchAndSortReferrals(entityId: any, entityType: any, page: number, size: number, sort: string, order: string, searchList?: any[], referralCode?: any): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = null;
    if (entityId) {
      url = API_FETCH_ENTITIES + '/' + entityId + '?page=' + page;
    } else {
      url = API_FETCH_ENTITIES + '?page=' + page;
    }

    if (entityType) {
      url += `&entityType=${entityType}`;
    }

    if (size != null) {
      url += '&size=' + size;
    }

    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    if (referralCode) {
      url += '&referralCode=' + referralCode;
    }
    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

  searchAndSortVendors(entityId: string, page: number, size: number, sort: string, order: string, entityType: string, searchList?: any[]): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = API_FETCH_ENTITIES;

    if (entityId) {
      url += `/${entityId}`;
    }

    url += `?page=${page}&size=${size}&sort=${sort},${order},&entityType=${entityType}`;

    if (searchList && searchList.length > 0) {
      searchList.forEach(search => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }

    return this.http.get<PageableResponse<any>>(url, { params });
  }

  searchAndSortDashboardData(params: HttpParams): Observable<PageableResponse<any>> {
    let url = `${API_FETCH_DASHBOARD}?sort=createdOn,desc`;

    return this.http.get<PageableResponse<any>>(url, { params: params });
  }




  searchAndSortChamps(entityId: any, entityType: any, page: number, size: number, sort: string, order: string, searchList?: any[], cacheKey?: any): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = null;
    if (entityId) {
      url = API_FETCH_AGENCY + '/' + entityId + '?entityType=' + entityType;
    } else {
      url = API_FETCH_AGENCY + '?entityType=' + entityType;
    }

    url += '&page=' + page;
    if (size != null) {
      url += '&size=' + size;
    }

    if (order !== 'desc') {
      order = 'asc';
    }
    if (sort != null) {
      url += ('&sort=' + sort + ',' + order);
    } else {
      url += ('&sort=createdOn,desc');
    }

    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

  getAssignedAgenciesAndCreatedByArray(id: any) {
    const url = API_JOB + '/filters?employerId=' + id;
    return this.http.get<any>(url);
  }

  updateProjectStatus(id: any, status: any) {
    const url = API_ASSIGN_ENTITY_IN_PROJECT + '/' + id + '/' + status;
    return this.http.get<any>(url);
  }

  getJobDetailsById(id, params) {
    const url = API_JOB + '/' + id;
    return this.http.get<any>(url, { params: params });
  }

  createQuotation(obj) {
    const url = GET_QUOTATION;
    return this.http.post<any>(url, obj);
  }

  updateQuotation(obj) {
    const url = GET_QUOTATION + '/' + obj.id;
    return this.http.put<any>(url, obj);
  }

  getQuotations(params) {
    const url = GET_QUOTATION;
    return this.http.get<any>(url, { params: params });
  }

  getQuotationById(id) {
    const url = GET_QUOTATION + '/' + id;
    return this.http.get<any>(url);
  }

  updateQuoteStatus(id: any, status: any) {
    const url = UPDATE_QUOTATION_STATUS + '/' + id + '/' + status;
    return this.http.get<any>(url);
  }

  createPO(obj) {
    const url = GET_PO;
    return this.http.post<any>(url, obj);
  }

  getPOById(id) {
    const url = GET_PO + '/' + id;
    return this.http.get<any>(url);
  }

  updatePO(obj, id) {
    const url = GET_PO + '/' + id;
    return this.http.put<any>(url, obj);
  }

  updatePOStatus(id: any, status: any) {
    const url = UPDATE_PO_STATUS + '/' + id + '/' + status;
    return this.http.get<any>(url);
  }


  getProjectsBasedOnEntity(id: any) {
    const url = GET_PROJECTS_BY_ENTITYID + '/' + id;
    return this.http.get<any>(url);
  }

  // refresh Quote
  setRefreshQuotePage(data?: any) {
    this.refreshQuotePage.next(data);
  }

  getRefreshQuotePage(): Subject<any> {
    return this.refreshQuotePage;
  }

  // refresh PO
  setRefreshPOPage(data?: any) {
    this.refreshPOPage.next(data);
  }

  getRefreshPOPage(): Subject<any> {
    return this.refreshPOPage;
  }

  // refresh Workorder
  setRefreshWorkorderPage(data?: any) {
    this.refreshWorkorderPage.next(data);
  }

  getRefreshWorkorderPage(): Subject<any> {
    return this.refreshWorkorderPage;
  }

  // refresh Billing
  setRefreshBillingPage(data?: any) {
    this.refreshBillingPage.next(data);
  }

  getRefreshBillingPage(): Subject<any> {
    return this.refreshBillingPage;
  }

  // Save billing data to local storage
  saveBillingData(data: any): void {
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  // Retrieve billing data from local storage
  getBillingData(): any {
    const storedData = localStorage.getItem(this.storageKey);
    return storedData ? JSON.parse(storedData) : null;
  }

  // Clear billing data from local storage
  clearBillingData(): void {
    localStorage.removeItem(this.storageKey);
  }

  exportBillingData(params) {
    return this.http.get(API_WORK_ORDER_EXPORT, { params, responseType: 'blob', observe: 'response' });
  }

  // fetch Workorders By Job Id
  fetchWorkorderByJobId(obj) {
    const url = API_WORK_ORDER + '/search';
    return this.http.post<any>(url, obj);
  }

  // fetch Workorders By Job Id
  fetchWorkorderByJobIdWithPagination(params, pazeSize, pageNumber) {
    const url = API_WORK_ORDER + '/search/paginated?pazeSize=' + pazeSize + '&pageNumber=' + pageNumber;
    return this.http.post<any>(url, params);
  }

  // fetch Billing Summary
  fetchBillingSummary(jobId) {
    const url = GET_BILLINGS + '/summary?jobId=' + jobId;
    return this.http.get<any>(url);
  }

  // get billing lists
  getBillingList(jobId: any, entityId: any, params?: any) {
    const url = GET_BILLINGS + '?jobId=' + jobId + entityId;
    return this.http.get<any>(url, { params: params });
  }

  // create bill for job
  createBill(obj: any) {
    const url = GET_BILLINGS;
    return this.http.post<any>(url, obj);
  }

  // update bill for job
  updateBill(obj: any, id: any) {
    const url = GET_BILLINGS + '/' + id;
    return this.http.put<any>(url, obj);
  }

  // update bill status for job
  updateBillingStatus(id: any, status: any) {
    const url = GET_BILLINGS + '/' + id + '/' + status;
    return this.http.get<any>(url);
  }

  // fetch BillD etails By Workorder Id
  fetchBillDetailsByWorkorderId(jobId, entityId, workOrderId) {
    const url = GET_BILLINGS + '?jobId=' + jobId + entityId + '&workOrderId=' + workOrderId;
    return this.http.get<any>(url);
  }

  // Upload signature image
  uploadSignatureImages(file: any): Observable<any> {
    console.log(file)
    let filename = null;
    if (!file.name) {
      filename = "IMG-" + this.randomFileName(5) + ".png";
    } else {
      filename = file.name;
    }
    const formData: FormData = new FormData();
    formData.append("image", file, filename);

    return this.http.post<S3File>(UPLOAD_SIGNATURE, formData, {
      reportProgress: true
    });
  }

  // Upload PDF 
  uploadPdf(file: any): Observable<any> {
    console.log(file)
    let filename = null;
    if (!file.name) {
      filename = "Signed-contract-" + this.randomFileName(5) + ".pdf";
    } else {
      filename = file.name;
    }
    const formData: FormData = new FormData();
    formData.append("image", file, filename);


    return this.http.post<S3File>(UPLOAD_SIGNATURE, formData, {
      reportProgress: true,
      // headers: {
      //   Authorization: this.authService.basicAuthHeader,
      //   'Content-Type': 'application/x-www-form-urlencoded',
      //   // 'accept': 'application/pdf'
      // }
    });
  }


  PostChunkMethod(api, formData, headers, chunkNumber, totalChunks) {
    return this.http.post<S3File>(api, formData, {
      reportProgress: true,
      // headers: {
      //   Authorization: this.authService.basicAuthHeader,
      // }
    });
  }

  PostChunkWholeMethod(api, formData, totalChunks) {
    return this.http.post<S3File>(api, formData, {
      reportProgress: true,
      // headers: {
      //   Authorization: this.authService.basicAuthHeader,
      // }
    });
  }

  // Generate random file name
  randomFileName(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  }

  // Upload signed contract
  uploadSignedContract(obj: any): Observable<any> {
    return this.http.post<S3File>(API_ENTERPRISE_SIGN_CONTRACT, obj, {
      reportProgress: true
    });
  }

  // Fetch signed document
  fetchSignedDocument(quoteId: any) {
    const url = FETCH_SIGNED_DOCUMENT + '/' + quoteId;
    return this.http.get<any>(url);
  }

  fetchAssignedVendorsOfProject(projectId: any) {
    const url = API_FETTCH_ASSIGNED_VENDORS + '/' + projectId;
    return this.http.get<any>(url);
  }

  getTimesheetData(jobId: any, groupBy: any, workOrderPage: number, workOrderSize: number, applicantPage: number, applicantSize: number, sort: string, order: string, searchList?: any[], cacheKey?: any): Observable<PageableResponse<any>> {
    let params = new HttpParams();
    let url = null;
    if (jobId) {
      url = API_TIMESHEET + '/' + jobId + '?groupBy=' + groupBy;
    } else {
      url = API_TIMESHEET + '?groupBy=' + groupBy;
    }

    // if(groupBy == ""){
    url += '&workOrderPage=' + workOrderPage;
    if (workOrderSize != null) {
      url += '&workOrderSize=' + workOrderSize;
    }
    // }

    // if(groupBy == ""){
    // url += '&applicantPage=' + applicantPage;
    // if (applicantSize != null) {
    //   url += '&applicantSize=' + applicantSize;
    // }
    // }

    // if (order !== 'desc') {
    //   order = 'asc';
    // }
    // if (sort != null) {
    //   url += ('&sort=' + sort + ',' + order);
    // } else {
    //   url += ('&sort=createdOn,desc');
    // }

    if (searchList && searchList.length > 0) {
      _.forEach(searchList, (search) => {
        if (search.column && search.content) {
          params = params.append(search.column, search.content);
        }
      });
    }
    return this.http.get<PageableResponse<any>>(url, { params: params });
  }

  fetchTimesheetFilter(projectId: any, filter: any) {
    const url = API_TIMESHEET_FILTER + '/' + projectId + '?' + filter;
    return this.http.get<any>(url);
  }

  // update timesheet follow-up status
  updateTimeSheetStatus(obj: any, id: any) {
    const url = API_JOB_APPLICATION + '/' + id + '/follow-up-status';
    return this.http.put<any>(url, obj);
  }


  getAllAgents(entity_id) {
    const url = GET_ALL_AGENTS + '?entity_id=' + entity_id;
    return this.http.get<any>(url);
  }

  getAllAgentsList(entity_id: string, agent_category?: string) {
    let url = GET_ALL_AGENTS_LIST + '?entity_id=' + entity_id;
    if (agent_category) {
      url += '&agent_category=' + agent_category;
    }

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.get<any>(url, { headers });
  }

  getAllOutcomesList(entity_id: string, agent_id?: string, project_id?: string) {
    let url = GET_ALL_OUTCOMES + '?entity_id=' + entity_id;

    if (agent_id) {
      url = url + '&agent_id=' + agent_id;
    }
    if (project_id != null && String(project_id).trim() !== '') {
      url = url + '&project_id=' + encodeURIComponent(String(project_id));
    }
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.get<any>(url, { headers });
  }

  /**
   * Async export of "Connected Leads" as an Excel file.
   *
   * The backend no longer streams the file from /downloadConnectedLeadsExcel; that
   * endpoint now kicks off a background export (HTTP 202) and we poll
   * /downloadConnectedLeadsExcelStatus until a presigned S3 download URL is ready.
   *
   * Emits exactly once with the ready payload, or errors with:
   *  - 'EXPORT_TIMEOUT' when it is still processing after `timeoutMs`
   *  - the backend error message on { status: 'failed' } or HTTP 404
   */
  exportConnectedLeadsExcel(
    projectId: string,
    outcomes?: string[],
    observedStatus?: string,
    startDate?: string,
    endDate?: string,
    pollIntervalMs = 3000,
    timeoutMs = 5 * 60 * 1000
  ): Observable<{ downloadUrl: string; filename: string; expiresIn?: number }> {
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    const deadline = Date.now() + timeoutMs;
    const outcomesParam = outcomes && outcomes.length
      ? `&outcomes=${encodeURIComponent(outcomes.join(','))}`
      : '';
    // Exports one row per lead that has ever held the status, so the file
    // length matches the count shown on the card.
    const observedParam = observedStatus
      ? `&observed_status=${encodeURIComponent(observedStatus)}`
      : '';
    // A half-filled range is not a range - the API rejects one date without
    // the other, so only send it once both are set (matches buildCallHistoryFilters).
    const dateParam = startDate && endDate
      ? `&start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`
      : '';
    const startUrl = DOWNLOAD_CONNECTED_LEADS_EXCEL
      + `?project_id=${encodeURIComponent(projectId)}${outcomesParam}${observedParam}${dateParam}`;

    return this.http.get<any>(startUrl, { headers }).pipe(
      switchMap((startRes) => {
        const exportId = startRes && (startRes.export_id || startRes.exportId);
        if (!exportId) {
          return throwError('Export could not be started.');
        }
        return this.pollConnectedLeadsExcelStatus(projectId, exportId, headers, deadline, pollIntervalMs);
      })
    );
  }

  private pollConnectedLeadsExcelStatus(
    projectId: string,
    exportId: string,
    headers: HttpHeaders,
    deadline: number,
    pollIntervalMs: number
  ): Observable<{ downloadUrl: string; filename: string; expiresIn?: number }> {
    const statusUrl = DOWNLOAD_CONNECTED_LEADS_EXCEL_STATUS
      + `?project_id=${encodeURIComponent(projectId)}&export_id=${encodeURIComponent(exportId)}`;

    return timer(0, pollIntervalMs).pipe(
      switchMap(() => this.http.get<any>(statusUrl, { headers }).pipe(
        // A 404 means the export is gone/expired — treat it as a terminal failure.
        catchError((err) => err && err.status === 404
          ? of({ status: 'failed', error: 'Export not found.' })
          : throwError(err)
        )
      )),
      map((res) => res || {}),
      // Keep polling while still processing AND within the time budget. `inclusive`
      // emits the first non-processing (ready/failed) response, or the last
      // processing response once the deadline passes, so `last()` can resolve it.
      takeWhile((res: any) => res.status === 'processing' && Date.now() < deadline, true),
      last(),
      switchMap((res: any) => {
        if (res.status === 'ready' && res.downloadUrl) {
          return of({
            downloadUrl: res.downloadUrl,
            filename: res.filename || `Connected_Leads_${projectId}.xlsx`,
            expiresIn: res.expiresIn
          });
        }
        if (res.status === 'failed') {
          return throwError(res.error || 'Export failed.');
        }
        return throwError('EXPORT_TIMEOUT');
      })
    );
  }

  /**
   * Entity-wide outcomes filter. Returns a flat, deduped list of outcome names
   * (base outcomes first, then each project's custom outcomes) for use as the
   * outcome filter options when viewing data across all projects of an entity.
   * Response shape: { outcomes: string[] }.
   */
  getHoaEntityOutcomesFilter(entityId: string) {
    const url = HOA_ENTITY_OUTCOMES_FILTER + `?entity_id=${encodeURIComponent(entityId)}`;
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    return this.http.get<any>(url, { headers });
  }

  createProject(obj: any) {
    const url = CREATE_PROJECT;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(url, obj, { headers });
  }

  createHoaProject(obj: any) {
    const url = PROJECT_HOA_URL;

    const headers = new HttpHeaders({
      'X-Suppress-Error': 'true',
      'x-api-key': PROJECT_API_KEY,
      // 'Content-Type': 'application/json'
    });

    return this.http.put<any>(url, obj, { headers });
  }

  cloneHoaProject(obj: { entityId: string; oldProjectId: string; newProjectId: string }) {
    const url = API_HOA_CLONE_PROJECT;
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(url, obj, { headers });
  }

  updateHoaProject(obj: any) {
    const url = PROJECT_HOA_URL;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      // 'Content-Type': 'application/json'
    });

    return this.http.post<any>(url, obj, { headers });
  }

  getHoaProject(
    entityId: string,
    projectId?: string,
    pageNum?: number,
    itemsPerPage?: number
  ) {
    const headers = new HttpHeaders({
      'X-Suppress-Error': 'true',
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    // Project metadata only. Do not use page_num/items_per_page for leads —
    // leads are loaded via getHoaProjectLeads.
    let url = PROJECT_HOA_URL + `?entity_id=${entityId}`;
    if (projectId != null && String(projectId).trim() !== '') {
      url += `&project_id=${encodeURIComponent(String(projectId))}`;
    }
    // Keep optional page params for any legacy callers that still pass them,
    // but new code should not rely on project.leads from this response.
    if (pageNum != null) {
      url += `&page_num=${pageNum}`;
    }
    if (itemsPerPage != null) {
      url += `&items_per_page=${itemsPerPage}`;
    }
    return this.http.get<any>(url, { headers });
  }

  /**
   * Paginated project leads (GET /hoaProjectLeads).
   * Prefer next_token cursor pagination over page numbers.
   * Treat next_token as opaque — never parse/decode/construct it.
   *
   * `name` and `mobile` are optional server-side filters and may be combined.
   * NOTE: when either is set the backend returns total_records/total_pages as
   * null (the cached count describes the whole project, not the filtered set),
   * so callers must hide totals and drive "load more" off has_next_page.
   */
  getHoaProjectLeads(options: {
    projectId: string;
    pageSize?: number;
    nextToken?: string | null;
    order?: 'asc' | 'desc';
    fields?: string;
    includeTotal?: boolean;
    entityId?: string;
    /** Case-insensitive partial match on the lead's name. */
    name?: string | null;
    /** Matches a full phone number or any fragment of one. */
    mobile?: string | null;
    /** Avoid unless numbered pages are required — expensive on the backend. */
    page?: number;
  }): Observable<any> {
    const headers = new HttpHeaders({
      'X-Suppress-Error': 'true',
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    let params = new HttpParams().set('project_id', String(options.projectId));

    const pageSize = options.pageSize != null ? Number(options.pageSize) : 50;
    if (Number.isFinite(pageSize) && pageSize > 0) {
      params = params.set('page_size', String(Math.min(pageSize, 200)));
    }

    if (options.nextToken) {
      params = params.set('next_token', String(options.nextToken));
    }
    if (options.order === 'asc' || options.order === 'desc') {
      params = params.set('order', options.order);
    }
    if (options.fields) {
      params = params.set('fields', options.fields);
    }
    if (options.includeTotal) {
      params = params.set('include_total', 'true');
      if (options.entityId) {
        params = params.set('entity_id', String(options.entityId));
      }
    }
    if (options.page != null && Number.isFinite(Number(options.page))) {
      params = params.set('page', String(options.page));
    }

    const name = (options.name || '').trim();
    if (name) {
      params = params.set('name', name);
    }
    const mobile = (options.mobile || '').trim();
    if (mobile) {
      params = params.set('mobile', mobile);
    }

    return this.http.get<any>(PROJECT_HOA_LEADS_URL, { headers, params }).pipe(
      map((res) => this.normalizeHoaProjectLeadsResponse(res))
    );
  }

  /** Normalize leads list response to { leads, pagination }. */
  private normalizeHoaProjectLeadsResponse(res: any): {
    leads: any[];
    pagination: any;
  } {
    if (!res) {
      return { leads: [], pagination: null };
    }
    let leads: any[] = [];
    // API shape: { items: [...], pagination: {...} }
    if (Array.isArray(res.items)) {
      leads = res.items;
    } else if (Array.isArray(res.leads)) {
      leads = res.leads;
    } else if (Array.isArray(res.records)) {
      leads = res.records;
    } else if (Array.isArray(res.data)) {
      leads = res.data;
    } else if (res.data && Array.isArray(res.data.items)) {
      leads = res.data.items;
    } else if (res.data && Array.isArray(res.data.leads)) {
      leads = res.data.leads;
    } else if (res.data && Array.isArray(res.data.records)) {
      leads = res.data.records;
    }

    const pagination =
      res.pagination ||
      (res.data && res.data.pagination) ||
      null;

    return { leads, pagination };
  }

  sendChatMessage(entityId: string, projectId: string, message: string) {
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    const body = {
      entityId: entityId,
      projectId: projectId,
      message: message
    };

    return this.http.post<any>(PROJECT_CHAT_URL, body, { headers });
  }

  updateProject(obj: any) {
    const url = UPDATE_PROJECT;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(url, obj, { headers });
  }

  deleteProject(obj: any) {
    const url = DELETE_PROJECT;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(url, obj, { headers });
  }

  getProjectById(entityId: string, projectId: string) {
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = PROJECT_HOA_URL + `?entity_id=${entityId}&project_id=${projectId}`;
    return this.http.get<any>(url, { headers });
  }

  createLeadUser(obj: any, entity_id: any, project_id: any) {
    const url = CREATE_LEADS_USER + `?entity_id=${entity_id}&project_id=${project_id}`;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(url, obj, { headers });
  }

  createLeadUserHoa(obj: any, entity_id: any, project_id: any) {
    const url = CREATE_LEADS_USER_HOA + `?entity_id=${entity_id}&project_id=${project_id}`;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(url, obj, { headers });
  }

  inviteReferral(obj: any, entity_id: any) {
    const url = API_INVITE_AGENT + `${entity_id}`;
    return this.http.post<any>(url, obj);
  }

  /**
   * Adds stream URL to the selected project
   * @param streamData - Object containing stream_id, stream_url, and project_id
   * @returns Observable with API response
   */
  addStreamUrlToProject(streamData: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": "LiEw44aP9W74NhiuuXq3f8MUpvJYpRoF3VukyHHQ",
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post(API_VIDEO_STREAM, streamData, { headers });
  }

  getStreamsByProject(projectId: string): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": "LiEw44aP9W74NhiuuXq3f8MUpvJYpRoF3VukyHHQ",
      'Content-Type': 'application/json'
    });

    const url = `${API_VIDEO_STREAM}?project_id=${projectId}`;

    return this.http.get<any[]>(url, { headers });
  }

  addKeywordToStream(keywordData: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": "LiEw44aP9W74NhiuuXq3f8MUpvJYpRoF3VukyHHQ",
      'Content-Type': 'application/json'
    });

    return this.http.post(`${API_KEYWORD}`, keywordData, { headers });
  }

  getKeywordsByStream(streamId: string): Observable<any[]> {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": "LiEw44aP9W74NhiuuXq3f8MUpvJYpRoF3VukyHHQ",
      'Content-Type': 'application/json'
    });

    return this.http.get<any[]>(`${API_KEYWORD}?stream_id=${streamId}`, { headers });
  }

  getDetectionResults(streamId: string, projectId: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      "X-Api-Key": "LiEw44aP9W74NhiuuXq3f8MUpvJYpRoF3VukyHHQ",
      'Content-Type': 'application/json'
    });

    const url = `${API_DETECTION}?stream_id=${streamId}&project_id=${projectId}`;

    return this.http.get<any>(url, { headers }).pipe(
      tap((res) => this.detectionResultsSubject.next(res))
    );
  }

  setTabIndex(index: number) {
    this.tabIndexSubject.next(index);
  }


  updateICP(entityId: string, projectId: string, icpProfile: any): Observable<any> {
    const url = UPDATE_ICP_API;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    const body = {
      entity_id: entityId,
      project_id: projectId,
      icp_profile: icpProfile
    };

    return this.http.post<any>(url, body, { headers });
  }

  getHoaProjectInitialEmailTemplate(entityId: string, projectId: string): Observable<any> {
    const url = GET_HOA_PROJECT_INITIAL_EMAIL_TEMPLATE;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    return this.http.get(url, {
      headers,
      params: {
        entity_id: entityId,
        project_id: projectId
      }
    });
  }

  sendEmail(
    emailObj: { client_email: string; client_name: string }[],
    entityId: string,
    projectId: string,
    refreshToken: string
  ): Observable<any> {
    const url = SEND_INITIAL_EMAIL;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    const params = new HttpParams()
      .set('entity_id', entityId)
      .set('project_id', projectId)
      .set('refresh_token', refreshToken);

    return this.http.post(url, emailObj, { headers, params });
  }

  pauseWorkflow(entityId: string, projectId: string) {
    const url = API_HOA_WORKFLOW_PAUSE;
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    const body = {
      entityId: entityId,
      projectId: projectId
    };
    return this.http.post(url, body, { headers });
  }

  /**
   * Disable (or re-enable) tasks for leads whose latest status matches
   * overallStatus. Used to auto-disable pending schedules/tasks for leads
   * that already reached a terminal outcome, e.g. right after pauseWorkflow.
   */
  editProjectTasks(entityId: string, projectId: string, mode: 'disable' | 'enable', overallStatus?: string[], reason?: string) {
    const url = EDIT_PROJECT_TASKS;
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    const body: any = {
      project_id: projectId,
      entity_id: entityId,
      mode: mode
    };
    if (overallStatus && overallStatus.length) {
      body.overall_status = overallStatus;
    }
    if (reason) {
      body.reason = reason;
    }
    return this.http.post(url, body, { headers });
  }

  /** Poll an async editProjectTasks job (project-wide or overall_status-scoped) started above. */
  getEditProjectTasksStatus(projectId: string, jobId: string) {
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    const params = new HttpParams()
      .set('project_id', projectId)
      .set('job_id', jobId);
    return this.http.get<any>(EDIT_PROJECT_TASKS_STATUS, { headers, params });
  }


  fetchPlivoPhoneNumbers() {
    console.log("fetchPlivoPhoneNumbers called")
    const url = PLIVO_PHONE_NUMBER;
    return this.http.get<any>(url);
  }

  listPhoneNumbers() {
    const url = PURCHASED_PHONE_NUMBERS;
    return this.http.get<any>(url);
  }

  /**
   * Lead counts by outcome for one project.
   *
   * With start_date and end_date (IST YYYY-MM-DD, both or neither) the counts
   * cover only leads called in that window, each bucketed by the status of its
   * latest call in it — the same rule getAllJobsStatus dedups by, so a card's
   * count is the number of rows the table shows for the same window.
   *
   * observed_status_counts and reviewed_by_human_count come back only without a
   * range: neither "ever held this status" nor the review flag is answerable
   * inside a window, so the API omits them rather than reporting a wrong zero.
   *
   * date_basis only matters together with start_date/end_date: 'lead_added'
   * re-scopes the same window to when leads were ingested rather than when
   * they were last contacted (the API's default).
   */
  fetchLeadsStatusCount(
    project_id?: string,
    reviewed_by_human?: boolean,
    start_date?: string,
    end_date?: string,
    date_basis?: 'latest_contact' | 'lead_added'
  ) {
    const url = PROJECT_LEADS_STATUS_API;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    let params = new HttpParams();
    if (project_id != null && String(project_id).trim() !== '') {
      params = params.set('project_id', String(project_id));
    }
    if (reviewed_by_human === true) {
      params = params.set('reviewed_by_human', 'true');
    } else if (reviewed_by_human === false) {
      params = params.set('reviewed_by_human', 'false');
    }
    if (start_date && end_date) {
      params = params.set('start_date', start_date);
      params = params.set('end_date', end_date);
    }
    if (date_basis) {
      params = params.set('date_basis', date_basis);
    }
    return this.http.get<any>(url, { params, headers });
  }

  /**
   * INTERNAL-only: list post-call analysis LLM runs.
   *
   * The lambda re-checks that entityId is an INTERNAL entity, so this is a
   * convenience wrapper, not the access control.
   */
  fetchCallAnalysisLogs(
    entityId: string,
    filters: {
      projectId?: string;
      jobId?: string;
      callSid?: string;
      startDate?: string;
      endDate?: string;
      outcome?: string;
      direction?: string;
      normalizedOnly?: boolean;
      errorsOnly?: boolean;
      page?: number;
      pageSize?: number;
    } = {}
  ) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      'X-Api-Key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    let params = new HttpParams().set('entity_id', entityId);
    if (filters.projectId) { params = params.set('project_id', filters.projectId); }
    if (filters.jobId) { params = params.set('job_id', filters.jobId); }
    if (filters.callSid) { params = params.set('call_sid', filters.callSid); }
    if (filters.startDate) { params = params.set('start_date', filters.startDate); }
    if (filters.endDate) { params = params.set('end_date', filters.endDate); }
    if (filters.outcome) { params = params.set('outcome', filters.outcome); }
    if (filters.direction) { params = params.set('direction', filters.direction); }
    if (filters.normalizedOnly) { params = params.set('normalized_only', 'true'); }
    if (filters.errorsOnly) { params = params.set('errors_only', 'true'); }
    if (filters.page) { params = params.set('page', String(filters.page)); }
    if (filters.pageSize) { params = params.set('page_size', String(filters.pageSize)); }
    return this.http.get<any>(GET_CALL_ANALYSIS_LOGS, { headers, params });
  }

  /** INTERNAL-only: one analysis run with its prompt, outcome list and raw response. */
  fetchCallAnalysisLog(entityId: string, jobId?: string, callSid?: string) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      'X-Api-Key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    let params = new HttpParams().set('entity_id', entityId);
    if (jobId) { params = params.set('job_id', jobId); }
    if (callSid) { params = params.set('call_sid', callSid); }
    return this.http.get<any>(GET_CALL_ANALYSIS_LOG, { headers, params });
  }

  /** INTERNAL-only: the task prompt the simulator starts from. */
  fetchCallAnalysisPromptTemplate(entityId: string, direction: string = 'outbound') {
    const params = new HttpParams().set('entity_id', entityId).set('direction', direction);
    return this.http.get<any>(GET_CALL_ANALYSIS_PROMPT_TEMPLATE, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /**
   * INTERNAL-only: simulate one call with candidate definitions and prompt.
   * Nothing is saved - the call keeps its original outcome.
   */
  replayCallAnalysis(entityId: string, payload: {
    job_id?: string;
    call_sid?: string;
    transcript?: string;
    outcome_definitions: { outcome_name: string; outcome_description: string }[];
    prompt_template: string;
    model?: string;
    questions?: string[];
  }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(REPLAY_CALL_ANALYSIS, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /** INTERNAL-only: simulate up to 50 stored calls with one candidate definition set. */
  replayCallAnalysisBatch(entityId: string, payload: {
    job_ids: string[];
    outcome_definitions: { outcome_name: string; outcome_description: string }[];
    prompt_template: string;
    model?: string;
  }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(REPLAY_CALL_ANALYSIS_BATCH, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /**
   * Rewrite a project's outcome definitions with AI.
   *
   * The backend feeds the model the call script, the outcome names and the
   * post-call classifier's own prompt, so the rewritten descriptions are
   * written for the classifier that will read them. Names come back unchanged
   * and nothing is persisted - apply the result and save as usual.
   */
  generateOutcomeDefinitions(entityId: string, payload: {
    outcomes: { outcome_name: string; outcome_description: string }[];
    final_prompt: string;
    project_id?: string;
    direction?: string;
    model?: string;
  }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(GENERATE_OUTCOME_DEFINITIONS, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /** Start or resume the iterative outcome-definition review chat. */
  startOutcomeReviewChat(entityId: string, payload: {
    outcomes: { outcome_name: string; outcome_description: string }[];
    final_prompt: string;
    project_id?: string;
    direction?: string;
    model?: string;
    chat_id?: string;
  }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(START_OUTCOME_REVIEW_CHAT, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /** Continue the review chat with a message and/or batched answers + feedback. */
  continueOutcomeReviewChat(entityId: string, payload: {
    chat_id: string;
    message?: string;
    answer?: { question_id?: string; selected?: string; note?: string };
    answers?: { question_id?: string; selected?: string; note?: string }[];
    suggestion_feedback?: {
      suggestion_id: string;
      decision: 'accept' | 'reject' | 'edit';
      edited_description?: string | null;
      feedback?: string;
    };
    suggestion_feedbacks?: {
      suggestion_id: string;
      decision: 'accept' | 'reject' | 'edit';
      edited_description?: string | null;
      feedback?: string;
    }[];
  }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(CONTINUE_OUTCOME_REVIEW_CHAT, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /** Load a review chat by id, or the latest active chat for a project. */
  getOutcomeReviewChat(entityId: string, opts: { chat_id?: string; project_id?: string }) {
    let params = new HttpParams().set('entity_id', entityId);
    if (opts.chat_id) {
      params = params.set('chat_id', opts.chat_id);
    }
    if (opts.project_id) {
      params = params.set('project_id', opts.project_id);
    }
    return this.http.get<any>(GET_OUTCOME_REVIEW_CHAT, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /**
   * Return final outcomes from a review chat for the form.
   * Does not persist to the project — apply into the FormArray and save as usual.
   */
  applyOutcomeReviewChat(entityId: string, payload: {
    chat_id: string;
    outcomes?: { outcome_name: string; outcome_description: string }[];
  }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(APPLY_OUTCOME_REVIEW_CHAT, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /**
   * Re-run post-call analysis on stored calls and save the result.
   *
   * Uses the project's CURRENT outcome definitions against each row's stored
   * transcript, and runs the same follow-up actions a finished call would.
   * Max 25 job ids per request — chunk larger selections.
   */
  reevaluateCallAnalysis(entityId: string, payload: {
    project_id: string;
    job_ids: string[];
  }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(REEVALUATE_CALL_ANALYSIS, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /**
   * Backfill jev_outcome on explicit selected calls, for QA comparison.
   * Max 25 job_ids per request - chunk larger selections (same cap and
   * reason as reevaluateCallAnalysis: API Gateway's 29s window).
   */
  backfillJevOutcome(entityId: string, payload: { project_id: string; job_ids: string[] }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(BACKFILL_JEV_OUTCOME, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /**
   * Start an async Jev outcome backfill over every call in a project.
   *
   * Independent second-opinion classifier, for comparison against the
   * existing Outcome column only - writes just jev_outcome /
   * jev_outcome_confidence, never status, never call actions. Returns
   * immediately with a job_id; poll getBackfillJevOutcomeProjectStatus.
   */
  startBackfillJevOutcomeProject(entityId: string, payload: { project_id: string }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(START_BACKFILL_JEV_OUTCOME_PROJECT, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  getBackfillJevOutcomeProjectStatus(projectId: string, jobId: string) {
    const params = new HttpParams()
      .set('project_id', projectId)
      .set('job_id', jobId);
    return this.http.get<any>(BACKFILL_JEV_OUTCOME_PROJECT_STATUS, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /**
   * Preview a project's outcome names/definitions and the default candidate
   * models before running an accuracy search (INTERNAL only). Writes nothing.
   */
  getOutcomeAccuracySearchOutcomes(entityId: string, projectId: string) {
    const params = new HttpParams()
      .set('entity_id', entityId)
      .set('project_id', projectId);
    return this.http.get<any>(OUTCOME_ACCURACY_SEARCH_OUTCOMES, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /**
   * Start an automated outcome-accuracy search over a project's
   * human-reviewed calls (INTERNAL only). Returns immediately with a
   * job_id; poll getOutcomeAccuracySearchStatus for progress and results.
   * Writes nothing to the project.
   */
  startOutcomeAccuracySearch(entityId: string, payload: {
    project_id: string;
    direction?: string;
    models?: string[];
    definition_variants?: number;
    sample_size?: number;
    target_accuracy?: number;
  }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(START_OUTCOME_ACCURACY_SEARCH, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  getOutcomeAccuracySearchStatus(entityId: string, projectId: string, jobId: string) {
    const params = new HttpParams()
      .set('entity_id', entityId)
      .set('project_id', projectId)
      .set('job_id', jobId);
    return this.http.get<any>(OUTCOME_ACCURACY_SEARCH_STATUS, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /**
   * Apply a finished search's winning combination to the real project
   * (INTERNAL only) - a separate, explicit action from running the search.
   */
  applyOutcomeAccuracySearchResult(entityId: string, payload: { project_id: string; job_id: string }) {
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(APPLY_OUTCOME_ACCURACY_SEARCH_RESULT, payload, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  private callAnalysisHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      'X-Api-Key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
  }

  updateJobsStatusHumanReview(
    entityId: string,
    body: {
      projectId: string;
      peopleId: string;
      jobId: string;
      reviewedByHuman: boolean;
      outcome: string;
      humanComment?: string;
      disableExistingTask?: boolean;
      /** Corrected "why this outcome" text. Omit to leave it alone; '' clears it. */
      statusReason?: string;
      /**
       * Corrected answers. The backend takes ONLY the answer of each row —
       * question text comes from the project's question set and rows the client
       * invents are dropped.
       */
      questionsAsked?: { question: string; answer: string }[];
    }
  ) {
    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      'X-Api-Key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.put<any>(API_UPDATE_JOBS_STATUS_HUMAN_REVIEW, body, { headers, params });
  }

  /** Whether a person has taken this lead's chat over from the AI. */
  getChatTakeover(entityId: string, projectId: string, peopleId: string) {
    const params = new HttpParams()
      .set('entity_id', entityId)
      .set('project_id', projectId)
      .set('people_id', peopleId);
    return this.http.get<ChatTakeoverState>(API_CHAT_TAKEOVER, {
      headers: this.callAnalysisHeaders(), params
    });
  }

  /** Take the lead's chat over (the AI stops replying) or hand it back. */
  setChatTakeover(entityId: string, projectId: string, peopleId: string, active: boolean) {
    return this.http.post<ChatTakeoverState>(API_CHAT_TAKEOVER, {
      entity_id: entityId, project_id: projectId, people_id: peopleId, active
    }, { headers: this.callAnalysisHeaders() });
  }

  /** Send a person's reply in a taken-over chat (WhatsApp or website chat). */
  sendChatHumanReply(entityId: string, projectId: string, peopleId: string, message: string) {
    return this.http.post<any>(API_CHAT_HUMAN_REPLY, {
      entity_id: entityId, project_id: projectId, people_id: peopleId, message
    }, { headers: this.callAnalysisHeaders() });
  }

  /** The lead's jobs_status records (calls and chats), as the activity history shows them. */
  getJobsStatusByClient(peopleId: string, projectId: string, clientNumber: string) {
    const params = new HttpParams()
      .set('people_id', peopleId)
      .set('project_id', projectId)
      .set('client_number', clientNumber);
    return this.http.get<any>(API_UPDATE_JOB_STATUS, {
      headers: new HttpHeaders({ 'x-api-key': PROJECT_API_KEY }), params
    });
  }

  /**
   * Sign off the outcome's "add in other project" push for one job record.
   *
   * The entity id travels twice, as the `entity_id` query param and as
   * `entityId` in the body — that is what the endpoint expects. Only the API
   * key is sent: this endpoint takes no basic auth.
   */
  approveAddInOtherProject(
    entityId: string,
    body: { projectId: string; peopleId: string; jobId: string }
  ) {
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    const params = new HttpParams().set('entity_id', entityId);
    return this.http.post<any>(
      API_APPROVE_ADD_IN_OTHER_PROJECT,
      { ...body, entityId },
      { headers, params }
    );
  }

  getOutreachActivityBuffer(projectId: string, limit = 50) {
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    return this.http.get<any>(GET_OUTREACH_ACTIVITY_BUFFER, {
      headers,
      params: {
        projectId,
        limit: String(limit)
      }
    });
  }

  downloadProjectWhatsAppDocuments(projectId: string, clientNumber?: string): Observable<any> {
    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });
    let params = new HttpParams().set('project_id', String(projectId).trim());
    if (clientNumber && String(clientNumber).trim() && String(clientNumber).trim() !== 'Reveal') {
      params = params.set('client_number', String(clientNumber).trim());
    }
    return this.http.get<any>(DOWNLOAD_PROJECT_WHATSAPP_DOCUMENTS, { headers, params });
  }

  updateTaskCompletion(job_id: string, task_id: string, completion_reason: string, entity_id: string) {
    const url = API_UPDATE_TASK_COMPLETION;

    const headers = new HttpHeaders({
      Authorization: this.authService.basicAuthHeader,
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    const body = {
      job_id: job_id,
      task_id: task_id,
      completion_reason: completion_reason,
      entity_id: entity_id
    };

    return this.http.post<any>(url, body, { headers });
  }

  updateProjectName(entityId: string, projectId: string, projectName: string): Observable<any> {
    const url = API_UPDATE_PROJECT_NAME;

    const headers = new HttpHeaders({
      'x-api-key': PROJECT_API_KEY,
      'Content-Type': 'application/json'
    });

    const body = {
      entityId: entityId,
      projectId: projectId,
      projectName: projectName
    };

    return this.http.post<any>(url, body, { headers });
  }

}
